import axios from 'axios';

export async function printQrLabel(
  orderNumber: string | number,
  customerName: string,
): Promise<void> {
  await axios.post('/api/print-qr-label', { orderNumber, customerName });
}
